import {
  Button,
  Icon,
  IconButton,
  Tooltip,
  Typography,
} from '@wisecare-tech/design-system-web';
import { GetSacConfig } from 'domain/usecases/sacConfig/remote';
import { makeReduxActiveMessage } from 'main/factories/usecases/message/Update';
import { makeRemoteGetSacConfig } from 'main/factories/usecases/sacConfig/GetSacConfig';
import React, { useCallback, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  InfoActionsContainer,
  SacActionsButtonsContainer,
  SacSection,
} from './styles';
import { iModalSupportInformation } from './types';

export const SacActions: React.FC = () => {
  const [sacConfig, setSacConfig] = React.useState<
    GetSacConfig.Model | undefined
  >(undefined);
  const [loading, setLoading] = React.useState<boolean>(false);

  const { id } = useParams<{ id: string }>();

  const history = useHistory();

  const loadSacConfig = useCallback(async () => {
    const loadConfig = makeRemoteGetSacConfig();
    setLoading(true);
    try {
      const response = await loadConfig.get({
        orgId: String(id),
      });
      setSacConfig(response);
    } catch (error) {
      toast.error('Erro ao carregar configurações do SAC');
    } finally {
      setLoading(false);
    }
  }, [id]);

  const handleCopyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    toast.success('Copiado para a área de transferência');
  };

  const openSupportInformationModal = () => {
    const data: iModalSupportInformation = {
      ...sacConfig?.config,
      email: sacConfig?.config.supportEmail ?? '',
      phones: sacConfig?.config.phones ?? [],
      schedule: sacConfig?.config.schedule ?? [],
    };

    makeReduxActiveMessage().active({
      data,
      title: 'Título do modal',
      active: 'supportInformation',
      actionOk: () => history.push(`/sac/${id}/settings`),
    });
  };

  const openEmbedCodeModal = () => {
    const domain = window.location.origin;
    const code = `<a href="${domain}/sac/subject?token=${sacConfig?.config.apiKey}" target="_blank"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style="cursor:pointer"><rect width="40" height="40" rx="6" fill="#DD0404"/><path d="M13.7279 19.5795H13.4307L13.7658 17.0184H13.9872C14.6364 17.0184 15.0706 17.1048 15.2898 17.2777C15.5091 17.4505 15.6187 17.752 15.6187 18.182C15.6187 18.6921 15.4859 19.0525 15.2203 19.2633C14.9589 19.4741 14.4614 19.5795 13.7279 19.5795Z" fill="#FDFDFD"/><path d="M19.7063 23.165H19.3269L19.6557 20.7178H20.0035C20.716 20.7178 21.2008 20.8042 21.4579 20.977C21.7151 21.1457 21.8437 21.4344 21.8437 21.8434C21.8437 22.324 21.6877 22.6654 21.3757 22.8678C21.068 23.0659 20.5115 23.165 19.7063 23.165Z" fill="#FDFDFD"/><path d="M19.8454 19.1938L20.1426 16.9489H20.3134C20.9668 16.9489 21.4031 17.0247 21.6223 17.1765C21.8458 17.3283 21.9575 17.5939 21.9575 17.9733C21.9575 18.4159 21.8205 18.73 21.5465 18.9155C21.2724 19.101 20.775 19.1938 20.0541 19.1938H19.8454Z" fill="#FDFDFD"/><path fill-rule="evenodd" clip-rule="evenodd" d="M27.875 14.125C27.875 12.6812 26.6937 11.5 25.25 11.5H9.5C8.05625 11.5 6.875 12.6812 6.875 14.125V25.9375C6.875 27.3813 8.05625 28.5625 9.5 28.5625H14.75V32.5L20 28.5625H25.25C26.6937 28.5625 27.875 27.3813 27.875 25.9375V14.125ZM10.8127 24.6953H12.7604L13.222 21.1604H13.6647C14.4361 21.1604 15.0221 21.1098 15.4226 21.0086C15.8274 20.9075 16.1773 20.7409 16.4724 20.5091C16.8307 20.235 17.1005 19.8936 17.2818 19.4846C17.4673 19.0757 17.56 18.6162 17.56 18.1061C17.56 17.6719 17.4799 17.2798 17.3197 16.9299C17.1638 16.5758 16.934 16.2807 16.6305 16.0446C16.3564 15.8254 16.0381 15.6694 15.6756 15.5766C15.313 15.4839 14.6954 15.4375 13.8228 15.4375H12.0332L10.8127 24.6953ZM18.4352 15.4375L17.2148 24.6953H19.3522C20.3597 24.6953 21.0785 24.6553 21.5085 24.5752C21.9385 24.4951 22.299 24.3581 22.5899 24.1641C22.9735 23.9112 23.2665 23.5908 23.4689 23.2029C23.6712 22.8151 23.7724 22.3809 23.7724 21.9003C23.7724 21.3522 23.6038 20.899 23.2665 20.5407C22.9335 20.1781 22.4718 19.9526 21.8816 19.8641C22.4845 19.7797 22.9609 19.5394 23.3108 19.1432C23.6607 18.7469 23.8356 18.2494 23.8356 17.6508C23.8356 17.3093 23.7682 16.9994 23.6333 16.7212C23.5026 16.443 23.3065 16.2006 23.0452 15.994C22.788 15.7916 22.476 15.6483 22.1093 15.564C21.7425 15.4797 21.1565 15.4375 20.3513 15.4375H18.4352Z" fill="#FDFDFD"/><path d="M29.1875 23.3322L33.125 27.25V12.8125L29.1875 16.7303V23.3322Z" fill="#FDFDFD"/></svg></a>`;

    makeReduxActiveMessage().active({
      active: 'incorporationCode',
      actionOk: () => handleCopyToClipboard(code),
      data: {
        code,
      },
    });
  };

  useEffect(() => {
    loadSacConfig();
  }, [loadSacConfig]);

  return (
    <SacSection>
      <SacActionsButtonsContainer>
        <InfoActionsContainer>
          <Typography variant="b2_14semibold">SAC - AtendeFácil</Typography>
          <Typography variant="b4_14regular" color="black.4">
            Um canal de comunicação oferecido para resolver dúvidas,
            solicitações e fornecer suporte aos clientes por meio de chamadas de
            vídeo incorporados ao seu sistema.
          </Typography>
        </InfoActionsContainer>
        <Link to={`/sac/${id}/settings`}>
          <Button variant="secondary" size="sm">
            <Icon name="settings" />
            Configurações
          </Button>
        </Link>
        <Button
          variant="secondary"
          size="sm"
          disabled={!sacConfig?.enabled}
          onClick={openEmbedCodeModal}
        >
          <Icon name="code" />
          Incorporar
        </Button>
        <Tooltip content="Ver informações">
          <IconButton
            variant="primary"
            icon="info"
            size="sm"
            disabled={loading}
            onClick={openSupportInformationModal}
          />
        </Tooltip>
      </SacActionsButtonsContainer>
    </SacSection>
  );
};
